<template>
  <div class="w-full">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CarProgress from '@/helpers/CarProgress'

export default {
  name: 'MiaSettingsIndex',

  data() {
    return {
      progress: new CarProgress(),
      customerPortalProgress: new CarProgress()
    }
  },

  computed: {
    ...mapGetters('settings', ['settings'])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        if (settings) {
          this.updateProgress(settings)
        }
      }
    }
  },

  created() {
    this.initProgress()
  },

  mounted() {
    eventBus.$emit('mia-loading-ended')
  },

  methods: {
    initProgress() {
      this.progress.setup({
        invoice: {
          invoiceData: {
            item_accounting_receiver_email: true,
            item_accounting_receiver_name: true
          },
          sepaData: {
            item_accounting_sepa: value => value === 'Y',
            item_accounting_holder: true,
            item_accounting_iban: true,
            item_accounting_bic: true
          },
          pricingData: {
            item_accounting_baserate: true,
            item_accounting_car_price: true,
            item_accounting_cars_included: true
          }
        },
        calculations: {
          calculationsData: {
            item_config_provision_deviation: true,
            item_config_default_margin_customer: true,
            item_config_default_margin_partner: true,
            item_config_default_margin_retailer: true,
            item_config_seller_provision: true,
            item_config_salary_mode: true
          }
        },
        publishing: {
          generalData: {
            item_mobilede_defaulttext: true
          },
          servicesData: {
            item_mobilede_id: true,
            item_juhuauto_id: true
          }
        },
        texts: {
          generalData: {
            item_offer_defaulttext: true,
            item_offer_teaser: true,
            item_confirmation_defaulttext: true,
            item_mediator_teaser: true
          }
        },
        dat: {
          generalData: {
            item_dat_product: true,
            item_dat_id: true,
            item_dat_username: true,
            item_dat_autoupdate: true
          }
        },
        services: {
          phoenixData: {
            item_phoenix_merchant_id: true
          },
          bdkData: {
            item_configurator_id: true
          }
        },
        mia: {
          ui: {
            item_use_beta_ui: () => true
          },
          ...(this.isAllowedDealer('customer_communication') ? {
            customerEmailCommunication: {
              item_customer_communication_mail_smtp_username: true,
              item_customer_communication_mail_smtp_password: true,
              item_customer_communication_mail_smtp_host: true,
              item_customer_communication_mail_smtp_port: true,
              item_customer_communication_mail_smtp_security: true
            }
          } : {})
        },
        cars: {
          ...(this.isAllowedDealer('import_production_data') && this.isAllowedDealer('import_production_data_check') ? {
            importProductionDataCheck: {
              item_productiondata_check_enabled: true,
              item_productiondata_check_daily_times: true,
              item_productiondata_check_notification_receivers: true
            }
          } : {}),
          ...(this.isAllowedDealer('substitute_mobility') ? {
            substituteMobility: {
              item_documents: value => Array.isArray(value) && value.length > 0
            }
          } : {})
        }
      })

      this.customerPortalProgress.setup({
        email: {
          generalData: {
            item_customer_portal_mail_smtp_username: true,
            item_customer_portal_mail_smtp_host: true,
            item_customer_portal_mail_smtp_port: true,
            item_customer_portal_mail_smtp_security: true
          }
        }
      })
    },

    updateProgress(settings) {
      this.progress.update(settings)
      this.customerPortalProgress.update(settings)
      this.$store.commit('progress/setProgress', {
        settingsBasics: {
          page: this.progress.pageProgress,
          section: this.progress.sectionProgress
        },
        customerPortal: {
          page: this.customerPortalProgress.pageProgress,
          section: this.customerPortalProgress.sectionProgress
        }
      })
    }
  }
}
</script>

<style lang="scss">
// TODO: Extract these styles, since they are shared with the new Car Add/Edit Views
input[type="text"].form-input,
input[type="number"].form-input,
input[type="date"].form-input,
input[type="time"].form-input,
select.form-select {
  &:focus {
    @apply outline-none #{!important};
    @apply shadow-outline #{!important};
  }
}

.form-input,
.form-select {
  &:required,
  &.is-required {
    border-left-width: calc(theme('width.px') * 3);
    border-left-color: theme('borderColor.orange-mia');
  }

  &.has-errors {
    @apply shadow-outline-error;
  }
}

.multiselect {
  &.is-required {
    .multiselect__tags {
      border-left-width: calc(theme('width.px') * 3);
      border-left-color: theme('borderColor.orange-mia');
    }
  }

  &.has-errors {
    .multiselect__tags {
      @apply shadow-outline-error;
    }
  }
}

input[type="date"],
input[type="time"] {
  &.form-input {
    @apply text-base;

    line-height: normal;
    height: 39px;
  }
}

input[type="text"].form-input {
  @apply text-base;
}

textarea.form-input {
  @apply text-base;

  line-height: normal;

  &:focus {
    @apply outline-none;
    @apply shadow-outline #{!important};
  }
}
</style>

<style lang="scss">
.tooltip {
  .tooltip-inner {
    @apply bg-gray-700;
    @apply text-sm;
    @apply px-2;
    @apply py-1;
    @apply rounded;
    @apply shadow-lg;
  }

  .tooltip-arrow {
    border-top-color: theme('borderColor.gray.700');
  }

  &[x-placement^="bottom"] .tooltip-arrow {
    border-bottom-color: theme('borderColor.gray.700');
  }
}
</style>
